/*  ========================================================================
    # Scripts - ShareMenu
    ========================================================================  */

/**
 *
 */

const ShareMenu = {
  cfg: {
    shareMenu: {
      element: document.querySelector('.c-share-menu'),
      elementActive: 'c-share-menu--active',
      button: document.querySelector('.c-share-menu__entry--button')
    }
  },

  /**
   * Show/hide the share menu.
   */
  handleShareMenuToggle() {
    this.cfg.shareMenu.button.addEventListener('click', () => {
      this.cfg.shareMenu.element.classList.toggle(this.cfg.shareMenu.elementActive);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.shareMenu.element !== undefined && this.cfg.shareMenu.element !== null) {
      this.handleShareMenuToggle();
    }
  }
};

export default ShareMenu;
